
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.483 3.161a2.931 2.931 0 00-2.04-2.035C19.618.638 12.28.638 12.28.638s-7.325-.012-9.17.488a2.93 2.93 0 00-2.034 2.035 30.42 30.42 0 00-.51 5.666c-.003 1.892.168 3.78.51 5.641a2.943 2.943 0 002.034 2.04c1.826.487 9.17.487 9.17.487s7.321 0 9.165-.488a2.944 2.944 0 002.04-2.039c.335-1.86.499-3.75.487-5.64.013-1.9-.15-3.797-.488-5.667zm-13.55 9.17V5.31l6.11 3.518-6.108 3.502h-.001z","fill":"#fff"}})])
          )
        }
      }
    